module.exports = "/packs/mouse-scroll-449e95500d7cec3a08a2cc70fbfb582e.gif";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/Shared/assets/images/mouse-scroll.gif
// module id = ./app/javascript/packs/Shared/assets/images/mouse-scroll.gif
// module chunks = 1